import { Component, input } from '@angular/core';

@Component({
  selector: 'app-ellipsis-loading',
  standalone: true,
  templateUrl: './ellipsis-loading.component.html',
  styleUrls: ['./ellipsis-loading.component.scss'],
  host: {
    '[attr.id]': "id() ? id() + '-ellipsis-loader' : 'global-ellipsis-loader'"
  }
})
export class EllipsisLoadingComponent {
  readonly id = input<string | undefined>(undefined);
}
